<template>
  <div class="filter">
    <div class="filter__header">
      <div class="filter__header__label">{{ label }}</div>
      <b-icon
        v-if="removable"
        class="filter__header__remove-button"
        icon="x"
        @click="$emit('removeFilter', this)"
        v-b-popover.hover.right="'Удалить фильтр'"
      />
    </div>
    <div class="filter__content">
      <slot></slot>
    </div>
    <div class="filter__add-value-button" v-if="displayAddValueButton">
      <p @click="$emit('addValue')">Добавить значение</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    displayAddValueButton: {
      type: Boolean,
      required: false
    },
    removable: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style lang="scss">
.filter {
  display: flex;
  flex-direction: column;
  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px black;
    &__label {
      font-size: 20px;
      margin-left: 5px;
    }
    &__remove-button {
      margin-right: 5px;
      font-size: 25px;
      cursor: pointer;
    }
  }
  &__content {
    margin: 0 5px;
    &__values {
      &__value {
        display: flex;
        flex-direction: row;
        margin-top: 5px;
        align-items: center;
        &__max {
          margin-left: 5px;
        }
        &__remove-button {
          height: 38px;
          min-width: 38px;
          padding: 0;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  &__add-value-button {
    font-size: 14px;
    text-align: right;
    margin-right: 5px;
    color: #007bff;
    & > p {
      display: inline-block;
      border-bottom: solid 1px transparent;
    }
    & > p:hover {
      border-bottom: solid 1px #0060c7;
      color: #0060c7;
      cursor: pointer;
    }
  }
}
</style>
